import { render, staticRenderFns } from "./identityVerify.vue?vue&type=template&id=f1d25692"
import script from "./identityVerify.vue?vue&type=script&lang=ts"
export * from "./identityVerify.vue?vue&type=script&lang=ts"
import style0 from "./identityVerify.vue?vue&type=style&index=0&id=f1d25692&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports